import { GzIncidentsStatusWebComponent } from './component/IncidentsStatusWebComponent';

export { GzIncidentsStatusWebComponent };
